import DeclarationIcon from "@mui/icons-material/Description";
import ListDeclarations from "./List";
import { DECLARATIONS, DocumentServicePath } from "utils/constants";
import CreateDeclarations from "./Create";
import EditDeclarations from "./Edit";
import ShowDeclarations from "./Show";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <DeclarationIcon />,
  name: DocumentServicePath + DECLARATIONS,
  title: "Декларации",
  list: <ListDeclarations />,
  create: <CreateDeclarations />,
  createPermission: permissions.canCreateDeclarations,
  edit: <EditDeclarations />,
  editPermission: permissions.canUpdateDeclarations,
  show: <ShowDeclarations />,
  showPermission: permissions.canPreviewDeclarations,
  permission: permissions.canPreviewDeclarations,
};
